<template>
  <FormWrapper grid>
    <slot name="header" />
    <form @submit.prevent="submit">
      <div class="relative col-span-1">
        <FormInput :show-label="false"
                   name="year"
                   placeholder="Year"
                   v-model="form.year"
                   class="sm:col-span-6"/>
      </div>

      <div class="relative col-span-2">
        <Autocomplete :show-label="false"
                      placeholder="Make"
                      :url="$route('ajax.vehicles.makes.autocomplete', { year: form.year })"
                      @change="form.make = $event"
                      :selected="form.make"
                      single
                      clear-on-blue
                      search-on-focus
                      />
      </div>

      <div class="relative col-span-2">
        <Autocomplete :show-label="false"
                      placeholder="Model"
                      :url="$route('ajax.vehicles.models.autocomplete', { year: form.year, make: form.make })"
                      @change="form.model = $event"
                      :selected="form.model"
                      single
                      clear-on-blue
                      search-on-focus
                      />
      </div>

      <div class="relative col-span-1">
        <Autocomplete :show-label="false"
                      placeholder="Submodel"
                      :url="$route('ajax.vehicles.submodels.autocomplete', {
                        year: form.year,
                        make: form.make,
                        model: form.model,
                      })"
                      @change="form.submodel = $event"
                      :selected="form.submodel"
                      single
                      clear-on-blue
                      search-on-focus
                      />
      </div>

      <FormActions :show-cancel="false"
                   submit-label="Search"
                   grid>
      </FormActions>
    </form>
  </FormWrapper>
</template>

<script>
import FormComponent from '@/pages/form-component'
import PageComponent from '@/pages/page-component'
import { Inertia } from '@inertiajs/inertia'
import Autocomplete from '@/components/form-autocomplete'

export default {
  mixins: [
    PageComponent,
    FormComponent,
  ],

  props: {
    filters: {
      type: Object,
      default: {},
    },
    formUrl: String,
  },

  components: {
    Autocomplete,
  },

  data() {
    return {
      form: {
        make: this.filters.make,
        model: this.filters.model,
        year: this.filters.year,
        submodel: this.filters.submodel,
      },
    }
  },

  methods: {
    submit() {
      Inertia.get(this.formUrl || this.$route('vehicles.index'), this.form)
    },
  },
}
</script>
